import React, { Component } from "react";
import * as d3 from "d3";

class progressChart extends Component {
  state = {
    tau: Math.PI * 2,
    arc_foreground: "",
    arc_background: "",
    foreground: "",
    background: ""
  };
  componentDidMount() {
    this.renderChart();
  }
  renderChart = () => {
    var val = this.props.percent;
    const { width, height, id, data } = this.props;
    const { tau } = this.state;

    var svg = d3.select(`#${id}`);

    var arc_foreground = d3.svg
      .arc()
      .innerRadius(62)
      .outerRadius(69)
      .startAngle(0);

    var arc_background = d3.svg
      .arc()
      .innerRadius(64)
      .outerRadius(66)
      .startAngle(0);

    var chart = svg
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .style("flex", 1)
      .style("align-self", "stretch")
      .attr("viewBox", `0 0 ${width} ${height}`);

    var g = chart
      .append("g")
      .attr(
        "transform",
        "translate(" + width / 2 + "," + (height - 10) / 2 + ")"
      )
      .append("g")
      .attr("class", "progress-meter");

    var title = chart
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + 185 + ")");

    var background = g
      .append("path")
      .datum({ endAngle: tau })
      .style("fill", "#4BDCD6")
      .attr("d", arc_background);

    var foreground = g
      .append("path")
      .datum({ endAngle: 0.127 * tau })
      .style("fill", "#485FFF")
      .attr("d", arc_foreground);

    // adding inner value
    var text = g
      .append("text")
      .attr("y", 10)
      .style("font-size", 22)
      .style("fill", "#000000eb")
      .style("text-anchor", "middle")
      .text(data.value);

    //adding outer title
    title
      .append("text")
      .style("font-size", 14)
      .style("fill", "#000000eb")
      .style("text-anchor", "middle")
      .text(data.name);

    this.setState({
      arc_foreground,
      arc_background,
      foreground,
      background
    });
    setTimeout(() => {
      this.preciseData();
    }, 3000);
  };

  arcTween = newAngle => {
    var { arc_foreground } = this.state;
    return function(d) {
      var interpolate = d3.interpolate(d.endAngle, newAngle);
      return function(t) {
        d.endAngle = interpolate(t);
        return arc_foreground(d);
      };
    };
  };

  // updates random data onmouse over
  // randomData = () => {
  //   let { foreground, tau } = this.state;
  //   foreground
  //     .transition()
  //     .duration(750)
  //     .attrTween("d", this.arcTween(Math.random() * tau));
  // };

  // updates correct data on mouse out
  preciseData = () => {
    let { foreground } = this.state;
    let { percent } = this.props.data;
    foreground
      .transition()
      .duration(750)
      .attrTween("d", this.arcTween(percent / (50 / 3.14)));
  };

  // mouseOverHandler = () => {
  //   setTimeout(() => {
  //     this.randomData();
  //   }, 200);
  // };

  // mouseOutHandler = () => {
  //   setTimeout(() => {
  //     this.preciseData();
  //   }, 200);
  // };

  render() {
    return (
      <div
        id={this.props.id}
        // onMouseEnter={() => this.mouseOverHandler()}
        // onMouseLeave={() => this.mouseOutHandler()}
      />
    );
  }
}

export default progressChart;



// WEBPACK FOOTER //
// ./src/components/d3Components/progressChart/progressChart.js